<div>
  <mat-form-field appearance="outline" class="flex-1-1-100">
    <mat-label>Title</mat-label>
    .
    <input matInput type="text" id="survey-execution-title" [(ngModel)]="title"
           placeholder="Title">
  </mat-form-field>
</div>

<div>
  <mat-form-field appearance="outline" class="flex-1-1-100">
    <mat-label>Description</mat-label>
    <textarea matInput type="text" [(ngModel)]="description"
              placeholder="Description" rows="5">
              </textarea>
  </mat-form-field>
</div>
<div>
  <mat-checkbox [(ngModel)]="isCollaborative">Collaborative response</mat-checkbox>
  <mat-checkbox [(ngModel)]="canAddNewRecord">Respondent can create new row</mat-checkbox>
</div>
